module.exports = __webpack_public_path__ + "static/media/pop-bg.a608e66c.jpg";